import { render, staticRenderFns } from "./ApplicantPreprojectPage.vue?vue&type=template&id=79897996&"
import script from "./ApplicantPreprojectPage.vue?vue&type=script&lang=js&"
export * from "./ApplicantPreprojectPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports